import {getResidentTestId} from "../../helper";
import {AdmissionFromSearch} from "../../../../services/AdmissionsService";
import {getAdmissionViewHref} from "../../../dashboard-cell/admissionRoutes";
import {StyledDropdownMenuItem} from "./styles";

export const ViewAdmissionDropdownItem = ({
  admission,
  label = "View Workflow",
}: {
  admission: AdmissionFromSearch;
  label?: string;
}) => (
  <StyledDropdownMenuItem
    asLink
    to={getAdmissionViewHref(admission.id)}
    testId={getResidentTestId(admission, "view")}
    target="_blank"
  >
    {label}
  </StyledDropdownMenuItem>
);
